import { Component, h, Prop, Watch } from '@stencil/core';
import { getQuestionListData } from '@ugc-components/ugc-pdp-question-and-answer/utils';
import { defaultSort } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import state from '@ugc-store';
import ViewDesktop from './view.desktop';
import ViewMobile from './view.mobile';

@Component({
  tag: 'ugc-qna-list',
  shadow: false,
})
export class UgcQnaList {
  @Prop() productId: number;

  async getQuestionList() {
    const {
      preference: { language },
    } = state;
    await getQuestionListData({
      productId: this.productId,
      sortId: defaultSort,
      cid: '',
      textToSearch: '',
      language,
      isFirst: true,
    });
  }

  async componentWillLoad() {
    this.getQuestionList();
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.getQuestionList();
  }

  render() {
    const { isDesktop } = state;

    return isDesktop ? <ViewDesktop /> : <ViewMobile />;
  }
}
